export const routes = {
  auth: {
    login: '/auth/local',
    refresh: '/auth/refresh',
    impersonateStop: '/auth/impersonate/stop',
    forgotPassword: '/auth/forgot-password',
    resetPassword: '/auth/reset-password',
  },
  users: {
    base: '/users',
    me: '/users/me',
    one: (id: string) => `/users/${id}`,
  },
  medias: {
    presigned: '/medias/presigned/',
    presignedByFile: '/medias/presigned/{asset}/{file}',
    images: '/medias/images',
    documents: '/medias/documents',
    videos: '/medias/videos',
  }
};
